export enum CompanySource {
    LXM = 1,
    EstonianBusinessRegister = 2
}

(CompanySource as any).__typeName = 'CompanySource';